/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import { Table } from '../../../atoms/table/Table';
import { translate } from '../../../../../api/utils/i18nHelper';
import { CELL_SIZE } from '../../../atoms/table/Cells';
import { RoleMatrix } from '../../../../../utils/my-puratos/roleUtils';
import { WithRole } from '../../../hoc/withRole';
import { connect } from 'react-redux';
import { selectIsPricingVatIncluded } from '../../../../../selectors/my-puratos/account';
import { useI18N } from '../../../hoc/withI18N';

export const ProductHeader = () => {
    const translation = useI18N();
    return (
        <Table.Header>
            <Table.Cell valign={'top'} align={'left'} size={CELL_SIZE._100}>
                {translation('Product')}
            </Table.Cell>
            <Table.Cell size={CELL_SIZE._equalLg} />
            <Table.Cell valign={'top'} align={'left'} size={CELL_SIZE._equal}>
                {translation('Package')}
            </Table.Cell>
            <WithRole roles={[RoleMatrix.puratosCustomerValidated]}>
                <Table.Cell
                    valign={'top'}
                    align={'left'}
                    size={CELL_SIZE._equal}
                >
                    {translation('Base price')}
                </Table.Cell>
                <Table.Cell
                    valign={'top'}
                    align={'left'}
                    size={CELL_SIZE._equal}
                >
                    {translation('Unit price')}
                </Table.Cell>
                <Table.Cell size={CELL_SIZE._125} />
                <Table.Cell size={CELL_SIZE._75} />
            </WithRole>
        </Table.Header>
    );
};

export const ProductFooter = connect((state) => ({
    isPricingVatIncluded: selectIsPricingVatIncluded(state),
    i18n: state.myPuratos_i18n.i18n,
}))(({ isPricingVatIncluded }) => {
    const translation = useI18N();
    return isPricingVatIncluded ? (
        <Table.Footer>
            <span className={'p-vat-text p-margin-left-sm p-margin-right-sm'}>
                {translation('Prices are incl. VAT')}
            </span>
        </Table.Footer>
    ) : null;
});
